import { Component, OnInit } from '@angular/core';
import { CalAngularService } from '@cvx/cal-angular';
import { PageLayout } from '@cvx/nextpage';
import { SecretConstants } from 'src/app/constants/Secret.constants';
import { IGenericApiResponseWithWorkflowRequest } from 'src/app/models/common/GenericApiResponseWithWorkflowRequest';
import { DirectoryDomain } from 'src/app/models/directory/enums/DirectoryDomain.enum';
import { IDirectoryUser } from 'src/app/models/directory/users/DirectoryUser';
import { IWorkflowRequest } from 'src/app/models/requests/WorkflowRequest';
import { SsUser } from 'src/app/models/secretServer/SsUser';
import { DirectoryGroupService } from 'src/app/services/directory/DirectoryGroup.service';
import { SecretServerService } from 'src/app/services/secretServer/secretServer.service';

@Component({
  selector: 'app-reactivate',
  templateUrl: './reactivate-secret-user.component.html'
})
export class ReactivateSecretUserComponent implements OnInit {

  PageLayout = PageLayout;
  userPrincipalName: string = "";
  checkingPermission: boolean = true;
  hasPermission: boolean = false;
  isSubmitting: boolean = false;
  submittedRequests: IWorkflowRequest[] = [];
  submitErrorMessage = { message: '', errors: [] };

  constructor(private readonly directoryGroupService: DirectoryGroupService,
    private readonly authService: CalAngularService,
    private readonly secretService: SecretServerService) { }

  async ngOnInit() {
    const foundUser: IDirectoryUser | null = await this.directoryGroupService.CheckMemberAsync(SecretConstants.AadUserAccessGroupId, DirectoryDomain.Chevron, this.authService.cvxClaimsPrincipal.objectId);
    if (foundUser) {
      this.userPrincipalName = this.authService.cvxClaimsPrincipal.userName;
      this.hasPermission = true;
    }

    this.checkingPermission = false;
  }

  onReactivate() {
    // clear error messages
    this.submitErrorMessage.message = '';
    this.submitErrorMessage.errors = [];
    this.isSubmitting = true;
    const observer = {
      next: (x: IGenericApiResponseWithWorkflowRequest<SsUser>) => {
        this.submittedRequests = x.requests;
      },
      error: (err: any) => {
        this.submitErrorMessage.message = err.statusText;
        this.submitErrorMessage.errors = err?.error?.errors ?? [];
        this.isSubmitting = false;
      },
      complete: () => {
        this.isSubmitting = false;
      }
    };

    let requestCall = this.secretService.ReactivateSecretUserAsync();
    requestCall.subscribe(observer);
  }
}
